module.exports = __webpack_public_path__ + "img/littleLine.5314845c.png";